import React from 'react';
import styled from 'styled-components';
import doCopy from 'copy-to-clipboard';
import { MessagePlugin, Tooltip } from 'tdesign-react';
import SvgIcon from '@/components/SvgIcon';

export default function Copyable({ copy }) {
  const handleClick = () => {
    doCopy(copy);
    MessagePlugin.info('已拷贝');
  };

  return (
    <Root>
      <Tooltip
        overlayInnerStyle={{ wordBreak: 'break-all' }}
        content={copy}
        destroyOnClose
        theme='light'
      >
        <Text>{copy}</Text>
      </Tooltip>
      <Tooltip content='拷贝' destroyOnClose theme='light'>
        <div>
          <Icon style={{ position: 'relative' }} onClick={handleClick} type='document-duplicate' />
        </div>
      </Tooltip>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
  margin-right: 4px;
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
  margin-bottom: 2px;
`;
